webpackJsonp([68932527527288],{

/***/ 1184:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _without = __webpack_require__(299);
	
	var _without2 = _interopRequireDefault(_without);
	
	var _difference = __webpack_require__(291);
	
	var _difference2 = _interopRequireDefault(_difference);
	
	var _FormError = __webpack_require__(200);
	
	var _FormError2 = _interopRequireDefault(_FormError);
	
	var _FormErrorLink = __webpack_require__(201);
	
	var _FormErrorLink2 = _interopRequireDefault(_FormErrorLink);
	
	var _FormWrap = __webpack_require__(202);
	
	var _FormWrap2 = _interopRequireDefault(_FormWrap);
	
	var _forms = __webpack_require__(49);
	
	var _fetch = __webpack_require__(63);
	
	var _api = __webpack_require__(54);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResetPasswordForm = function (_Component) {
	  _inherits(ResetPasswordForm, _Component);
	
	  function ResetPasswordForm() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ResetPasswordForm);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      backendErrorMsg: {},
	      email: '',
	      invalidFields: [],
	      isPending: false,
	      resetSuccessful: false,
	      validFields: []
	    }, _this.setFieldValue = function (e, fieldName) {
	      var value = e.target.value;
	      var validFields = [];
	
	      if (_this.state.validFields.indexOf(fieldName) !== -1) {
	        var _this$setState;
	
	        validFields = (0, _without2.default)(validFields, fieldName);
	        _this.setState((_this$setState = {}, _this$setState[fieldName] = value, _this$setState.validFields = validFields, _this$setState));
	      } else {
	        var _this$setState2;
	
	        _this.setState((_this$setState2 = {}, _this$setState2[fieldName] = value, _this$setState2));
	      }
	    }, _this.validateForm = function (e) {
	      e.preventDefault();
	      if (_this.isFormValid()) {
	        _this.resetPassword();
	      }
	    }, _this.isFormValid = function () {
	      var email = _this.state.email;
	
	      var invalidFields = [];
	
	      if (!(0, _forms.isEmailValid)(email)) {
	        invalidFields.push('email');
	      }
	
	      var validFields = (0, _difference2.default)(['email'], invalidFields);
	
	      _this.setState({
	        invalidFields: invalidFields,
	        backendErrorMsg: {},
	        validFields: validFields
	      });
	
	      return !invalidFields.length;
	    }, _this.resetPassword = function () {
	      var email = _this.state.email;
	
	      _this.setState({ isPending: true });
	      (0, _fetch.fetchApi)('POST', _api.API_FORGOT_PASSWORD, {
	        email: email
	      }).then(function () {
	        _this.setState({
	          resetSuccessful: true,
	          isPending: false
	        });
	      }).catch(_this.displayServerError);
	    }, _this.displayServerError = function (error) {
	      var backendErrorMsg = getErrorMessage(error);
	      _this.setState({
	        isPending: false,
	        backendErrorMsg: backendErrorMsg
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ResetPasswordForm.prototype.render = function render() {
	    var _state = this.state,
	        backendErrorMsg = _state.backendErrorMsg,
	        isPending = _state.isPending,
	        invalidFields = _state.invalidFields,
	        validFields = _state.validFields,
	        resetSuccessful = _state.resetSuccessful;
	
	
	    var fields = [{
	      errorMsg: 'Please enter a valid email address',
	      label: 'Email address',
	      name: 'email',
	      placeholder: 'you@example.com',
	      type: 'email'
	    }];
	
	    var buttonProps = {
	      text: 'Reset password'
	    };
	
	    var successMessage = "Password reset sent! You'll receive an email if you are registered on our system.";
	
	    return _react2.default.createElement(
	      _FormWrap2.default,
	      {
	        backendErrorMsg: backendErrorMsg,
	        buttonProps: buttonProps,
	        fields: fields,
	        messaging: this.props.messaging,
	        invalidFields: invalidFields,
	        isPending: isPending,
	        setFieldValue: this.setFieldValue,
	        validateForm: this.validateForm,
	        validFields: validFields,
	        action: _api.API_FORGOT_PASSWORD,
	        formSuccess: resetSuccessful && successMessage
	      },
	      _react2.default.createElement(_FormError2.default, backendErrorMsg)
	    );
	  };
	
	  return ResetPasswordForm;
	}(_react.Component);
	
	ResetPasswordForm.propTypes = {
	  messaging: _propTypes2.default.string.isRequired
	};
	exports.default = ResetPasswordForm;
	
	
	function getErrorMessage() {
	  return {
	    message: _react2.default.createElement(
	      'span',
	      null,
	      'There was an error resetting your password. Please try again or',
	      ' ',
	      _react2.default.createElement(
	        _FormErrorLink2.default,
	        { url: 'https://help.marvelapp.com/', isExternal: true },
	        'contact support'
	      ),
	      '.'
	    )
	  };
	}
	module.exports = exports['default'];

/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = FormError;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isArray = __webpack_require__(25);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _messageBlock = __webpack_require__(65);
	
	var _messageBlock2 = _interopRequireDefault(_messageBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function FormError(_ref) {
	  var message = _ref.message;
	
	  return _react2.default.createElement(
	    _spacing2.default,
	    { type: 'margin', position: 'top', size: 'm' },
	    _react2.default.createElement(
	      _messageBlock2.default,
	      { textAlign: 'left', type: 'error', fullWidth: true },
	      (0, _isArray2.default)(message) ? message.map(function (text) {
	        return _react2.default.createElement(
	          'div',
	          { key: text },
	          text
	        );
	      }) : message
	    )
	  );
	}
	
	FormError.propTypes = {
	  message: _propTypes2.default.string
	};
	module.exports = exports['default'];

/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = FormErrorLink;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _link = __webpack_require__(15);
	
	var _link2 = _interopRequireDefault(_link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function FormErrorLink(_ref) {
	  var isExternal = _ref.isExternal,
	      url = _ref.url,
	      children = _ref.children,
	      otherProps = _objectWithoutProperties(_ref, ['isExternal', 'url', 'children']);
	
	  var props = _extends({
	    type: 'opaqueReversed',
	    hasUnderline: true
	  }, otherProps);
	  return isExternal ? _react2.default.createElement(
	    _link2.default,
	    _extends({ url: url, target: '_blank' }, props),
	    children
	  ) : _react2.default.createElement(
	    _gatsbyLink2.default,
	    { to: url },
	    _react2.default.createElement(
	      _link2.default,
	      props,
	      children
	    )
	  );
	}
	
	FormErrorLink.propTypes = {
	  isExternal: _propTypes2.default.bool,
	  url: _propTypes2.default.string.isRequired,
	  children: _propTypes2.default.node.isRequired
	};
	module.exports = exports['default'];

/***/ }),

/***/ 1300:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = ResetPassword;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _link = __webpack_require__(15);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _ForgotPasswordForm = __webpack_require__(1184);
	
	var _ForgotPasswordForm2 = _interopRequireDefault(_ForgotPasswordForm);
	
	var _Page = __webpack_require__(16);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _AccountPagesWrap = __webpack_require__(146);
	
	var _AccountPagesWrap2 = _interopRequireDefault(_AccountPagesWrap);
	
	var _forms = __webpack_require__(49);
	
	var _urls = __webpack_require__(84);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ResetPassword(_ref) {
	  var history = _ref.history;
	
	  var messaging = {
	    header: _react2.default.createElement(
	      _maxWidth2.default,
	      { value: 300 },
	      _react2.default.createElement(
	        _spacing2.default,
	        { type: 'margin', size: 'xs', position: 'bottom' },
	        _react2.default.createElement(
	          _spacing2.default,
	          { type: 'margin', size: 'xl', sizeM: '0', position: 'right' },
	          _react2.default.createElement(
	            _heading2.default,
	            { tag: 'h1', size: 'xxxl', weight: 'bold' },
	            'Reset your password here'
	          )
	        )
	      )
	    )
	  };
	
	  var signinLinkWithRedirect = (0, _forms.getUrlWithRedirect)(_urls.SIGNIN);
	
	  return _react2.default.createElement(
	    _Page2.default,
	    {
	      title: 'Reset your password \u2013 Marvel',
	      meta: [{ name: 'description', content: '' }, { name: 'keywords', content: '' }],
	      header: false
	    },
	    _react2.default.createElement(
	      _AccountPagesWrap2.default,
	      { history: history },
	      _react2.default.createElement(_ForgotPasswordForm2.default, { messaging: messaging }),
	      _react2.default.createElement(
	        _paragraph2.default,
	        { size: 'm', color: 'slate' },
	        'Return to',
	        ' ',
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: signinLinkWithRedirect },
	          _react2.default.createElement(
	            _link2.default,
	            { type: 'blue' },
	            'sign in'
	          )
	        )
	      )
	    )
	  );
	}
	
	ResetPassword.propTypes = {
	  history: _propTypes2.default.object.isRequired
	};
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-signin-reset-password-index-js-7975edd62bbdc977a788.js